<template>
  <div class="c-leg d-flex align-items-start">
    <v-button
      variant="outline-primary"
      class="mr-2"
      name="button"
      :disabled="!leg"
      @click="legDeleted"
      :aria-label="$t('white-label.globalLabels.remove')"
    >
      X
    </v-button>
    <v-form-group class="leg-action mr-2">
      <v-form-select
        :value="action"
        :options="isStockLeg ? stockLegActionOptions : optionLegActionOptions"
        :disabled="!leg"
        @input="actionChanged"
        :aria-label="$t('white-label.globalLabels.action')"
      />
    </v-form-group>
    <v-form-number
      type="integer"
      class="leg-quantity-input mr-2"
      autocomplete="off"
      :min="1"
      :spin="false"
      :value="quantity"
      :disabled="!leg"
      @change="quantityChanged"
      @input="
        value => {
          if (!value) this.quantityChanged(0);
        }
      "
    />
    <div v-if="leg && leg.assetClass.id === 0" class="leg-description">
      <span> {{ leg.stock['q.RIC'].split('.')[0] }} </span>
      <v-flag :countryCode="leg.stock['q._COUNTRY']" />
      <span> {{ leg.stock['_CURR_SYMBOL'] }}</span>
      <v-fidlet :data="leg.stock['q._TRDPRC_1'] || ''" type="float.price" />
    </div>
    <div v-if="leg && leg.assetClass.id === 1" class="leg-description">
      <span> {{ leg.option['_UNDERLYING_RIC'].split('.')[0] }} </span>
      <v-flag :countryCode="leg.option['_COUNTRY']" />
      <span> {{ getFormattedMaturityDate(leg.option['xopt._MATURITY_ISO']) }} </span>
      <span> {{ leg.option['_CURR_SYMBOL'] }}</span>
      <v-fidlet :data="leg.option['xopt._STRIKE'] || ''" type="float.price" />
      <span> {{ leg.option['xopt._TYPE_CP'] === 'C' ? i18n('call') : i18n('put') }} </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'c-leg',
  props: {
    leg: {
      type: Object
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      action: 'BTO',
      quantity: '',
      legDescription: null
    };
  },
  watch: {
    leg: {
      handler: 'handleLeg',
      immediate: true
    }
  },
  computed: {
    stockLegActionOptions() {
      return [{ value: 'BTO', text: this.i18n('stock.BTO') }, { value: 'STO', text: this.i18n('stock.STO') }];
    },
    optionLegActionOptions() {
      return [
        { value: 'BTO', text: this.i18n('option.BTO') },
        { value: 'STO', text: this.i18n('option.STO') },
        { value: 'BTC', text: this.i18n('option.BTC') },
        { value: 'STC', text: this.i18n('option.STC') }
      ];
    },
    isStockLeg() {
      return this.leg && this.leg.assetClass.id === 0;
    }
  },
  methods: {
    i18n(key) {
      return this.$t(`white-label.widgets.optionChain.legs.${key}`);
    },
    legDeleted($event) {
      this.resetLeg();
      this.$emit('leg-deleted', $event);
    },
    actionChanged($event) {
      this.$emit('action-changed', $event);
    },
    quantityChanged(value) {
      this.$emit('quantity-changed', value);
    },
    handleLeg() {
      if (this.leg) {
        this.action =
          this.leg.assetClass.id === 0
            ? this.leg.action.shortname === 'B'
              ? 'BTO'
              : 'STO'
            : this.leg.action.shortname;
        this.quantity = this.leg.quantity;
      } else {
        // Reset Leg (UI) if leg has changed and is now null, e.g. due to new symbol entered in WOptionChainWidget which deletes all Legs
        this.resetLeg();
      }
    },
    // helpers
    getFormattedMaturityDate(maturity) {
      return moment(maturity).format('DD MMM YYYY');
    },
    resetLeg() {
      this.action = '';
      this.quantity = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-leg';
</style>
